import axios from "axios";

export const refreshApi = async () => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user?.refresh_token) {
    throw new Error("No refresh token available");
  }

  // User ID from response object
  const userId = user?.response?.id || user?.userDetails?.id;

  if (!userId) {
    throw new Error("No user ID found");
  }

  const payload = {
    refresh: user.refresh_token,
    userid: userId,
  };

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/enroll/web_token_refresh/`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    if (res.data?.status !== "success" || !res.data?.access) {
      throw new Error("Failed to refresh token - invalid response");
    }

    return res.data.access;
  } catch (error) {
    // Agar refresh token hi expire ho gaya
    if (error.response?.status === 401) {
      console.error("Refresh token expired or invalid");
    }

    throw error;
  }
};
